import { render, staticRenderFns } from "./projectDocumentBox.vue?vue&type=template&id=17ca4334&scoped=true"
import script from "./projectDocumentBox.vue?vue&type=script&lang=js"
export * from "./projectDocumentBox.vue?vue&type=script&lang=js"
import style0 from "./projectDocumentBox.vue?vue&type=style&index=0&id=17ca4334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca4334",
  null
  
)

export default component.exports